export function getAssigneeFlags(run) {
  if (!run) return { canReview: false, canApprove: false, canReject: false };
  return {
    canReview: !!run.can_review,
    canApprove: !!run.can_approve,
    canReject: !!run.can_reject,
  };
}

// Any reviewer in the chain (not just the current one) or the approver may view — no backend flag covers this, so compare ids.
export function isAnyReviewerOrApprover(run, user) {
  if (!run) return false;
  const employeeId = user?.employeeId;
  if (!employeeId) return false;

  const inChain = (run.review_steps || []).some(
    (step) => step.reviewer && String(step.reviewer) === String(employeeId)
  );
  const isApprover = run.approve_assignee && String(run.approve_assignee) === String(employeeId);

  return inChain || !!isApprover;
}

export function isActionableForMe(run) {
  const { canReview, canApprove } = getAssigneeFlags(run);
  return canReview || canApprove;
}
